import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
	TheFreeStyle01: 'TheFreeStyle01_Bear',
	TheFreeStyle02: 'TheFreeStyle02_Ray',
	TheFreeStyle03: 'TheFreeStyle03_Rhino',
	TheFreeStyle04: 'TheFreeStyle04_Seahorse',
	TheFreeStyle05: 'TheFreeStyle05_Whale',
};

export default {
	categoryKey: CategoryLists.Lifestyle.list.Terrace,
	cover: {
		caption: 'LandingPage.TheFreeStyle',
		backgroundImage: require('../../cover_image/small_animals_all.jpg'),
		mobileCoverImage: require('../../cover_image/small_animals_all.jpg'),
		mainImage: {
			src: require('../../../assets/categories/TheFreestyle.png'),
			pcSrc: require('../../../assets/categories/TheFreestyle.png'),
		},
	},
	box: {
		title: 'ProductPage.selectDesign', //i18n
		list: [
			{
				key: ModelKey.TheFreeStyle01,
				image: {
					mobile: require('../../thumbnail/freestyle_bear.png'),
					pc: require('../../thumbnail/freestyle_bear.png'),
				},
				title: 'ProductPage.FreestyleBear', // i18n
				level: 1,
				minutes: 30,
				allowInches: [],
			},
			{
				key: ModelKey.TheFreeStyle02,
				image: {
					mobile: require('../../thumbnail/freestyle_ray.png'),
					pc: require('../../thumbnail/freestyle_ray.png'),
				},
				title: 'ProductPage.FreestyleRay', // i18n
				level: 1,
				minutes: 30,
				allowInches: [],
			},
			{
				key: ModelKey.TheFreeStyle03,
				image: {
					mobile: require('../../thumbnail/freestyle_rhino.png'),
					pc: require('../../thumbnail/freestyle_rhino.png'),
				},
				title: 'ProductPage.FreestyleRhino', // i18n
				level: 1,
				minutes: 30,
				allowInches: [],
			},
			{
				key: ModelKey.TheFreeStyle04,
				image: {
					mobile: require('../../thumbnail/freestyle_seahorse.png'),
					pc: require('../../thumbnail/freestyle_seahorse.png'),
				},
				title: 'ProductPage.FreestyleSeahorse', // i18n
				level: 1,
				minutes: 30,
				allowInches: [],
			},
			{
				key: ModelKey.TheFreeStyle05,
				image: {
					mobile: require('../../thumbnail/freestyle_whale.png'),
					pc: require('../../thumbnail/freestyle_whale.png'),
				},
				title: 'ProductPage.FreestyleWhale', // i18n
				level: 1,
				minutes: 30,
				allowInches: [],
			},
		],
	},
	dezeenBox: {
	},
	worldcup:{
	},
	disney:{},
	ModelKey: ModelKey,
};

export const Boxes = {
	[ModelKey.TheFreeStyle01]: () => import('./thefreestyle_bear'),
	[ModelKey.TheFreeStyle02]: () => import('./thefreestyle_ray'),
	[ModelKey.TheFreeStyle03]: () => import('./thefreestyle_rhino'),
	[ModelKey.TheFreeStyle04]: () => import('./thefreestyle_seahorse'),
	[ModelKey.TheFreeStyle05]: () => import('./thefreestyle_whale'),
};
